import { X } from "lucide-react";
import { toast } from "@/lib/toast";
import { getChannelMeta, notificationTitle } from "@/lib/inboundNotifications";

/**
 * Interactive inbound toast — click opens the conversation.
 */
export function showInboundToast(notification, onOpen) {
  const title = notificationTitle(notification);
  const meta = getChannelMeta(notification.channel);
  toast.custom(
    (t) => (
      <div
        className="flex items-start gap-3 w-full text-left min-w-0 pointer-events-auto"
        data-testid={`inbound-toast-${notification.id}`}
      >
        <span className={`mt-0.5 inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${meta.iconBg}`}>
          <meta.Icon size={16} strokeWidth={1.75} />
        </span>
        <button
          type="button"
          className="min-w-0 flex-1 text-left outline-none group/btn"
          onClick={() => {
            toast.dismiss(t);
            onOpen(notification);
          }}
        >
          <div className="text-[13px] font-semibold text-slate-900 leading-snug truncate">{title}</div>
          {notification.preview ? (
            <div className="mt-1 text-[12px] text-slate-600 line-clamp-2 leading-relaxed">
              {notification.preview}
            </div>
          ) : null}
          <div className="mt-2 text-[11.5px] font-semibold text-indigo-600 group-hover/btn:text-indigo-700 flex items-center gap-1">
            Open conversation
          </div>
        </button>
        <button
          type="button"
          className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-slate-400 hover:bg-slate-100 hover:text-slate-700 transition-colors outline-none -mr-1 -mt-0.5"
          onClick={(e) => {
            e.stopPropagation();
            toast.dismiss(t);
          }}
          aria-label="Dismiss"
          data-testid="inbound-toast-dismiss"
        >
          <X size={14} strokeWidth={2} />
        </button>
      </div>
    ),
    { id: `inbound-notif-${notification.id}`, duration: 8000 },
  );
}
